import { Checkbox } from 'braid-design-system';
import React from 'react';

import type { UserRegistrationType } from 'src/types/userRegistrationType';

import { isEmailConsentRequired } from '../../utils';

interface EmailOptInProps {
  userRegistrationType: UserRegistrationType;
  valid: boolean;
  errorMessage: string;
  onChange: (value: boolean) => void;
  value: boolean;
}

export const EmailOptIn = (props: EmailOptInProps) => (
  <Checkbox
    id="email-opt-in"
    data={{ testid: 'email-opt-in-checkbox' }}
    checked={props.value}
    onChange={(event) => props.onChange(event.currentTarget.checked)}
    label={
      isEmailConsentRequired(props.userRegistrationType)
        ? "I consent to receiving emails about SEEK Business' services, latest business trends and helpful advice. Unsubscribe at any time."
        : "Send me emails about SEEK Business' services, latest business trends and helpful advice."
    }
    tone={props.valid ? 'neutral' : 'critical'}
    message={!props.valid && props.errorMessage}
  />
);
